<template>
  <div class="space-y-5 profile-page mt-6">
    <div
        class="profiel-wrap px-[35px] pb-10 md:pt-[84px] pt-10 rounded-lg bg-white dark:bg-slate-800 lg:flex lg:space-y-0 space-y-6 justify-between items-end relative z-[1]"
    >
      <div
          class="bg-slate-900 dark:bg-slate-700 absolute left-0 top-0 md:h-1/2 h-[150px] w-full z-[-1] rounded-t-lg"
      ></div>
      <div class="profile-box flex-none md:text-start text-center">
        <div class="md:flex items-end md:space-x-6 rtl:space-x-reverse">
          <div class="flex-none">
            <div
                class="md:h-[186px] md:w-[186px] h-[140px] w-[140px] md:ml-0 md:mr-0 ml-auto mr-auto md:mb-0 mb-4 rounded-full overflow-hidden ring-4 ring-slate-100 relative flex items-center justify-center"
            >
              <img v-if="userStore.getAvatar"
                   :src="userStore.getAvatar"
                   alt=""
                   class="w-full h-full object-cover rounded-full"
              />

              <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="#F1F5F9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="lucide lucide-user-icon lucide-user h-full w-full">
                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>

              <!--              <router-link
                                to="/app/profile-setting"
                                class="absolute right-2 h-8 w-8 bg-slate-50 text-slate-600 rounded-full shadow-sm flex flex-col items-center justify-center md:top-[140px] top-[100px]"
                            >
                              <myIcon icon="heroicons:pencil-square"/>
                            </router-link>-->
            </div>
          </div>
          <div class="flex-1">
            <div class="text-2xl font-medium text-slate-900 dark:text-slate-200 mb-[3px]">
              {{ userStore.getName }}
            </div>
            <div class="text-sm font-light text-slate-600 dark:text-slate-400">
              {{ userStore.getDiscordUsername ?? " " }}
            </div>
          </div>
        </div>
      </div>
      <!-- end profile box -->
      <div
          class="profile-info-500 md:flex md:text-start text-center flex-1 max-w-[516px] md:space-y-0 space-y-4"
      >
        <div class="flex-1" v-i>
          <div class="text-base text-slate-600 font-light dark:text-slate-300 mb-1">
            Total Balance
          </div>
          <div class="text-sm font-medium"
               :class="[userStore.getProfileAttribute('balance')<0 ? 'text-red-400':'text-slate-900 dark:text-slate-300']">
            {{ userStore.getProfileAttribute('balance') ? '$ ' + userStore.getProfileAttribute('balance') : 'ـــ' }}
          </div>
        </div>
        <!-- end single -->
        <!--        <div class="flex-1">
                  <div class="text-base text-slate-600 font-light dark:text-slate-300 mb-1">
                    Board Card
                  </div>
                  <div
                      class="text-sm text-slate-900 dark:text-slate-300 font-medium"
                  >
                    200
                  </div>
                </div>-->
        <!-- end single -->
        <div class="flex-1">
          <div class="text-base text-slate-600 font-light dark:text-slate-300 mb-1">
            {{ $t('message.verification state') }}
          </div>
          <div
              class="text-sm font-medium"
              :class="{
              'text-warning-600' : verificationState === 'Unverified',
              'text-success-600': verificationState === 'Approved',
              'text-danger-600' : verificationState === 'Rejected',
              'text-primary-600': verificationState === 'UnderReview',
              'animate-pulse': !verificationState
              }"
          >
            {{ verificationState ? $t('message.' + verificationState) : '. . .' }}
          </div>
        </div>
        <!-- end single -->
      </div>
      <!-- profile info-500 -->
    </div>
    <div class="grid grid-cols-12 gap-6">
      <div class="lg:col-span-12 col-span-12">
        <Modal
            :title="$t('message.delete_method')"
            labelClass="btn-outline-warning"
            ref="modal5"
            themeClass="bg-warning-500"
            :hasButton="false"
            :activeModal="isShowRemoveModal"
            @closeModal="isShowRemoveModal = false"
            centered
        >
          <div class="text-base mb-3 text-slate-600 dark:text-slate-300 text-center">
            {{ $t('message.delete_method') }} "{{ editItem.name }}"
          </div>
          <h4 class="font-medium text-lg text-slate-900 text-center">
            {{ $t('message.are you sure?') }}
          </h4>
          <template v-slot:footer>
            <div class="flex flex-row justify-center align-center w-full space-x-3 rtl:space-x-reverse">
              <Button
                  :text="$t('message.close')"
                  btnClass="btn-outline-dark "
                  @click="isShowRemoveModal = false"
              />
              <button @click="removePayment"
                      class="btn btn-warning block text-center flex items-center justify-center gap-3">
                {{ $t('message.delete') }}
                <Icon v-show="loading" icon="eos-icons:bubble-loading" height="24"/>
              </button>
            </div>
          </template>
        </Modal>
        <Card :title="$t('message.my_payment_methods')">
          <template #header>
            <Modal
                :title="$t('message.add_method')"
                :label="$t('message.add_method')"
                labelClass="bg-black-100 dark:bg-slate-900 dark:text-slate-50 btn-sm"
                ref="modal2"
                :activeModal="show"
                @closeModal="closeModal"
                centered
            >
              <div class="space-y-4">
                <div class="text-base text-slate-600 dark:text-slate-300 space-y-4">
                  <Alert
                      v-if="addedPaymentMethod"
                      type="success-outline"
                      dismissible
                      icon="akar-icons:double-check"
                  >
                    <span class="font-semibold">{{ $t('message.well_done') }}</span>
                  </Alert>
                  <Alert
                      v-if="addedPaymentMethod === false"
                      type="danger-outline"
                      dismissible
                      icon="heroicons-outline:exclamation"
                  >
                    <span class="font-semibold">{{ $t('message.failed') }}</span>
                  </Alert>
                  <TextInput v-if="isEdit"
                             :label="$t('message.type.label')"
                             name="type"
                             classInput="h-[48px]"
                             isReadonly
                             :modelValue="type"
                  />
                  <Select v-else :placeholder="$t('message.select_option')" :label="$t('message.type.label')"
                          :options="paymentTypes" v-model="type" :error="typeError"
                          @change="resetAddress"/>
                </div>
                <form v-if="type === 'Rial'" ref="form">
                  <div class="text-base text-slate-600 dark:text-slate-300 space-y-4">
                    <TextInput
                        :label="$t('message.name.label')"
                        type="text"
                        :placeholder="$t('message.name.placeholder')"
                        name="name"
                        v-model="name"
                        :error="nameError"
                        classInput="h-[48px]"
                    />
                    <TextInput
                        :label="$t('message.iban.label')"
                        :options="ibanMask"
                        placeholder="IR1234 1234 1234 1234 1234 1234"
                        name="iban"
                        v-model="iban"
                        :error="iban_error"
                        classInput="h-[48px] dir-ltr rtl:text-right"
                        isMask
                    />
                    <TextInput
                        :label="$t('message.cardNumber.label')"
                        :options="cardNumberMask"
                        placeholder="0000 0000 0000 0000"
                        name="cardNumber"
                        v-model="cardNumber"
                        :error="cardNumberError"
                        classInput="h-[48px] dir-ltr rtl:text-right"
                        isMask
                    />
                  </div>
                </form>
                <form v-else-if="type === 'Crypto'" ref="form">
                  <div class="text-base text-slate-600 dark:text-slate-300 space-y-4">
                    <TextInput
                        :label="$t('message.name.label')"
                        type="text"
                        :placeholder="$t('message.name.placeholder')"
                        name="name"
                        v-model="name"
                        :error="nameError"
                        classInput="h-[48px]"
                    />
                    <TextInput
                        :label="$t('message.network.label')"
                        placeholder="USDT TRC20"
                        name="network"
                        classInput="h-[48px]"
                        isReadonly
                        modelValue="USDT TRC20"
                    />
                    <TextInput
                        :label="$t('message.address.label')"
                        :placeholder="$t('message.type_your_usdt_address')"
                        name="address"
                        v-model="address"
                        :error="addressError"
                        classInput="h-[48px] rtl:placeholder-rtl"
                    />
                  </div>
                </form>
              </div>
              <template v-slot:footer>
                <Button
                    :text="$t('message.close')"
                    btnClass="btn-outline-dark "
                    @click="()=>{closeModal();}"
                />
                <button type="submit" @click="isEdit ? onEdit() : onSubmit()"
                        class="btn btn-dark text-center flex items-center justify-center gap-3">
                  {{ isEdit ? $t('message.edit') : $t('message.add') }}
                  <Icon v-show="loading" icon="eos-icons:bubble-loading" height="24"/>
                </button>
              </template>
            </Modal>
          </template>
          <div class="mx-auto mt-2">
            <payment-method @editModal="editModal" @removeModal="removeModal" :changeInMethods="changeInMethods"/>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "@/components/Card/index.vue";
import myIcon from "@/components/Icon/index.vue";
import {Icon} from "@iconify/vue";
import Button from "@/components/Button/index.vue";
import paymentMethod from "@/components/payment/method.vue";
import Modal from "@/components/Modal/Modal.vue";
import TextInput from "@/components/Textinput/index.vue";
import {computed, ref} from "vue";
import VueSelect from "@/components/Select/VueSelect.vue";
import Select from "@/components/Select/index.vue";
import {useField, useForm} from "vee-validate";
import * as yup from "yup";
import {useUserStore} from "@/stores/user";
import {usePaymentMethodsStore} from "@/stores/payment";
import Alert from "@/components/Alert/index.vue";
import {useToast} from "vue-toastification";
import {useI18n} from 'vue-i18n';

export default {
  components: {
    Card,
    myIcon,
    Button,
    paymentMethod,
    Modal,
    TextInput,
    VueSelect,
    Select,
    Icon,
    Alert,
  },
  setup() {
    const form = ref(null);
    const userStore = useUserStore();
    const paymentMethodsStore = usePaymentMethodsStore();
    const loading = ref(false)
    const addedPaymentMethod = ref(null);
    const show = ref(false);
    const isShowRemoveModal = ref(false);
    const isEdit = ref(false)
    const changeInMethods = ref(false)
    const {t, locale} = useI18n({useScope: 'global'})
    const modal2 = ref(null)

    const verificationState = computed(() => {
      return userStore.getProfileAttribute('verificationState')
    })

    const schema = yup.object({
      type: yup.string().required("Type is required").nullable("Type is required"),
      name: yup.string().required("Name is required").nullable("Name is required"),
      address: yup.string().when('type', {
        is: 'Crypto',
        then: () => yup.string().required("Address is required").nullable("Address is required").label('Address'),
        otherwise: () => yup.string().nullable(),
      }),
      iban: yup.string().when('type', {
        is: 'Rial',
        then: () => yup.string().required("Iban is required").min(31, 'Iban must be at least 26 characters').nullable("Iban is required").label('Iban'),
        otherwise: () => yup.string().nullable(),
      }),
      cardNumber: yup.string().when('type', {
        is: 'Rial',
        then: () => yup.string().required("Card number is required").min(19, 'Card number must be at least 16 characters').nullable("Card number is required").label('Card number'),
        otherwise: () => yup.string().nullable(),
      })
    })

    const formValues = {
      "type": null,
      "name": null,
      "network": "USDT TRC20",
      "address": null,
      "iban": null,
      "cardNumber": null,
    };

    const {resetForm, handleSubmit} = useForm({
      validationSchema: schema,
      initialValues: formValues,
    });

    const {value: type, errorMessage: typeError} = useField("type");
    const {value: name, errorMessage: nameError} = useField("name");
    const {value: network, errorMessage: networkError} = useField("network");
    const {value: address, errorMessage: addressError} = useField("address");
    const {value: iban, errorMessage: iban_error} = useField("iban");
    const {value: cardNumber, errorMessage: cardNumberError} = useField("cardNumber");

    const onSubmit = handleSubmit(async (values) => {
      console.log(values)
      loading.value = true;
      changeInMethods.value = false
      const payload = {
        "type": values.type,
        "name": values.name,
      }
      if (values.type === "Crypto") {
        payload.network = "USDT TRC20";
        payload.address = values.address;
      } else if (values.type === "Rial") {
        payload.iban = values.iban;
        payload.cardNumber = values.cardNumber
      }
      const addPaymentMethod = await paymentMethodsStore.addPaymentMethod(payload)
      loading.value = false;
      if (addPaymentMethod) {
        addedPaymentMethod.value = true
        resetForm();
        changeInMethods.value = true
      } else {
        addedPaymentMethod.value = false
      }
    })

    let paymentTypes = computed(() => [
          {
            value: "Rial",
            label: t('message.rial'),
          },
          {
            value: "Crypto",
            label: t('message.crypto_wallet'),
          },
        ]
    );

    function resetMyForm() {
      resetForm();
      addedPaymentMethod.value = null
      loading.value = false
    }

    function resetAddress(event) {
      addedPaymentMethod.value = null
      resetForm({
        values: {
          address: null,
          type: event.target.value
        },
      });
    }

    const ibanMask = {
      prefix: "IR",
      numericOnly: true,
      blocks: [6, 4, 4, 4, 4, 4],
      uppercase: true,
    }
    const cardNumberMask = {
      blocks: [4, 4, 4, 4],
      numericOnly: true,
    }

    const editItem = ref(null)

    function editModal(emittedValue) {
      show.value = true;
      isEdit.value = true;
      type.value = emittedValue.type
      name.value = emittedValue.name
      editItem.value = emittedValue
      if (emittedValue.type === "Crypto") {
        network.value = emittedValue.crypto.network;
        address.value = emittedValue.crypto.address;
      } else if (emittedValue.type === "Rial") {
        iban.value = emittedValue.rial.iban;
        cardNumber.value = emittedValue.rial.cardNumber;
      }
    }

    function removeModal(emittedValue) {
      console.log(emittedValue)
      editItem.value = emittedValue
      isShowRemoveModal.value = true
    }

    const onEdit = handleSubmit(async (values) => {
      loading.value = true;
      changeInMethods.value = false
      const payload = {
        "type": values.type,
        "name": values.name,
        "id": editItem.value.id
      }
      if (values.type === "Crypto") {
        payload.network = "USDT TRC20";
        payload.address = values.address;
      } else if (values.type === "Rial") {
        payload.iban = values.iban;
        payload.cardNumber = values.cardNumber
      }
      const editPaymentMethod = await paymentMethodsStore.updatePaymentMethod(payload)

      loading.value = false;
      if (editPaymentMethod) {
        addedPaymentMethod.value = true
        resetForm();
        changeInMethods.value = true
      } else {
        addedPaymentMethod.value = false
      }
    })

    function closeModal(emittedValue) {
      if (!emittedValue) {
        modal2.value.closeModal()
      }
      addedPaymentMethod.value = null
      show.value = false;
      isEdit.value = false;
      type.value = null
    }

    const toast = useToast();
    const message = computed(() => {
      return userStore.getErrorMessage;
    });

    async function removePayment() {
      loading.value = true;
      changeInMethods.value = false
      const removePaymentMethod = await paymentMethodsStore.removePaymentMethod({
        "id": editItem.value.id
      })
      loading.value = false;
      if (removePaymentMethod) {
        isShowRemoveModal.value = false
        changeInMethods.value = true
        toast.success("Deleted successfully", {
          timeout: 2000,
        });
      } else {
        toast.error(message.value, {
          timeout: 2000,
        });
      }
      isShowRemoveModal.value = false
    }


    return {
      name,
      nameError,
      address,
      addressError,
      network,
      networkError,
      iban,
      iban_error,
      type,
      typeError,
      resetMyForm,
      resetAddress,
      paymentTypes,
      onSubmit,
      loading,
      editModal,
      form,
      addedPaymentMethod,
      show,
      isShowRemoveModal,
      removeModal,
      isEdit,
      onEdit,
      closeModal,
      removePayment,
      editItem,
      changeInMethods,
      userStore,
      ibanMask,
      cardNumberMask,
      cardNumber,
      cardNumberError,
      modal2,
      locale,
      verificationState
    }
  }
};
</script>
<style lang="scss">
.dir-ltr {
  direction: ltr;
}

.dir-rtl {
  direction: rtl;
}

.placeholder-rtl::placeholder {
  text-align: right;
  direction: rtl;
}
</style>
